module.exports = __webpack_public_path__ + "img/outterEngraving.2bf3d23.webp";